export interface SettingsDTO {
    id: number;
    userId: number;
    timeZone: string;
    outlookHours: number;
    lookbackHours: number;
    keepDoneVisible: number;
    revisionsEnabled: boolean;
    showOnHold: boolean;
    taskNotificationsEnabled: boolean;
    taskNotificationTime: string;
    meetingNotificationsEnabled: boolean;
    meetingNotificationLeadTime: number;
    showWelcomePopup: boolean;
}

export interface SettingsWriteDTO {
    userId: number;
    timeZone: string;
    outlookHours: number;
    lookbackHours: number;
    keepDoneVisible: number;
    revisionsEnabled: boolean;
    showOnHold: boolean;
    taskNotificationsEnabled: boolean;
    taskNotificationTime: string;
    meetingNotificationsEnabled: boolean;
    meetingNotificationLeadTime: number;
    showWelcomePopup: boolean;
}

export function createSettings(userId: number, timeZone: string, outlookHours: number, lookbackHours: number, keepDoneVisible: number, revisionsEnabled: boolean, showOnHold: boolean
    , taskNotificationsEnabled: boolean, taskNotificationTime: string, meetingNotificationsEnabled: boolean, meetingNotificationLeadTime: number, showWelcomePopup: boolean) {
    return {
        userId: userId, timeZone: timeZone, outlookHours: outlookHours, lookbackHours: lookbackHours, keepDoneVisible: keepDoneVisible, revisionsEnabled: revisionsEnabled,
        showOnHold: showOnHold, taskNotificationsEnabled: taskNotificationsEnabled, taskNotificationTime: taskNotificationTime, meetingNotificationsEnabled: meetingNotificationsEnabled, meetingNotificationLeadTime: meetingNotificationLeadTime,
        showWelcomePopup: showWelcomePopup
    };
}